<div class="reservation-modal">
    <div class="reservation-modal__header">
        <div class="header-copy">
            <h2>Reservierung {{ data.reservationCode }}</h2>
            <p>Details und Bestellübersicht</p>
        </div>

        <button type="button" class="close-button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <section class="reservation-section">
        <div class="section-title">GAST</div>

        <div class="guest-name">{{ data.guestName }}</div>

        <div class="guest-meta-row">
            <div class="guest-meta">
                <mat-icon>mail</mat-icon>
                <span>{{ data.email }}</span>
            </div>

            <div class="guest-meta">
                <mat-icon>call</mat-icon>
                <span>{{ data.phone }}</span>
            </div>

            <div class="guest-meta">
                <mat-icon>group</mat-icon>
                <span>{{ data.persons }} Personen</span>
            </div>
        </div>
    </section>

    <section class="info-grid">
        <div class="info-item">
            <div class="info-label">Show</div>
            <div class="info-value">{{ data.showTitle }}</div>
        </div>

        <div class="info-item">
            <div class="info-label">Standort</div>
            <div class="info-value">{{ data.venueName }}</div>
        </div>

        <div class="info-item">
            <div class="info-label">Zeitblock</div>
            <div class="info-value">{{ data.block }} ({{ data.blockTime }})</div>
        </div>

        <div class="info-item">
            <div class="info-label">Tisch</div>
            <div class="info-value">{{ data.table }}</div>
        </div>
    </section>

    <section class="reservation-section reservation-section--order">
        <div class="order-header">
            <div class="section-title">BESTELLUNG</div>

            <span class="order-pill">
                <mat-icon>{{ data.source === 'Web' ? 'public' : 'desktop_windows' }}</mat-icon>
                {{ data.orderLabel }}
            </span>
        </div>

        <div class="order-items">
            <div class="order-row" *ngFor="let item of data.orderItems">
                <div class="order-name">{{ item.quantity }}× {{ item.name }}</div>
                <div class="order-price">{{ item.price }}</div>
            </div>
        </div>

        <div class="order-total">
            <span>Gesamt</span>
            <span>{{ data.amount }}</span>
        </div>
    </section>
</div>